import { rgba } from 'polished';
import colors, { palette } from './colors';
import fonts from './fonts';
import button from './components/button';
import input from './components/input';
import alert from './components/alert';
import modal from './components/modal';
import tabs from './components/tabs';
import contentBox from './components/contentBox';
import select from './components/select';
import textArea from './components/textArea';
import checkbox from './components/checkbox';
import tooltip from './components/tooltip';
import slider from './components/slider';
import upload from './components/upload'; // TODO: pensar em como criar um tema padrao

export default {
  // colors,
  // palette,
  fonts: fonts,
  alert: alert,
  button: button,
  contentBox: contentBox,
  textArea: textArea,
  checkbox: checkbox,
  modal: modal,
  tooltip: tooltip,
  slider: slider,
  select: select,
  tabs: tabs,
  input: input,
  upload: upload,
  colors: {
    primary: colors.periwinkle,
    error: colors.bittersweet
  },
  textColors: {
    primary: colors.slate
  },
  circularProgress: {
    color: colors.periwinkle
  },
  calendar: {
    maxWidth: '384px',
    textColor: colors.slate,
    closeButtonColor: colors.blueyGrey,
    selectedTextColor: colors.periwinkle,
    disabledTextColor: 'rgba(0, 0, 0, 0.38)',
    daySelectedColor: colors.white,
    toolbarTextColor: colors.lightGreyish,
    toolbarSelectedTextColor: colors.white,
    toolbarSelectedFontSize: '32px',
    toolbarSelectedFontFamily: 'Metropolis-SemiBold',
    viewContainer: {
      boxShadow: '0 6px 6px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: colors.white
    },
    dateViewHeader: {
      colorDayLabel: colors.bluishGrey,
      arrowColor: '#859099',
      borderBottomLeftRadius: '4.8px',
      borderBottomRightRadius: '4.8px'
    },
    toolbar: {
      backgroundColor: palette.primary,
      height: '88px',
      borderTopLeftRadius: '4.8px',
      borderTopRightRadius: '4.8px',
      padding: '16px 24px'
    },
    toolbarButton: {
      transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, font-size 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      fontSize: '14px',
      fontFamily: 'Metropolis-Regular',
      cursor: 'pointer'
    }
  },
  radio: {
    button: {
      checked: {
        color: colors.periwinkle
      },
      unchecked: {
        color: colors.cloudyBlue
      }
    },
    label: {
      color: colors.darkBlue
    }
  },
  "switch": {
    controller: {
      color: palette.primary,
      colorDisabled: colors.lightCloudyBlue,
      boxShadow: "0 6px 12px 0 ".concat(rgba(colors.electricViolet, 0.6))
    },
    text: {
      color: colors.slate
    }
  }
};